



























































































import { TEMPLATE_DETAIL_QUERY, TemplateDetail, TemplateDetailResult } from "@/models/queries/TemplateDetail";
import Vue from "vue";
import Component from "vue-class-component";
import { Action } from "vuex-class";
import { TemplateDetailVariables } from "@/models/queries/types/TemplateDetail";
import { graphqlClient } from "@/utils/graphql";
import { FetchResult } from "apollo-link";
import draggable from "vuedraggable";
import {
  SAVE_TEMPLATE_CHARACTERISTICS_ORDER,
  SaveTemplateCharacteristicsOrderResult
} from "@/models/mutations/SaveTemplateCharacteristicsOrder";
import { SaveTemplateCharacteristicsOrderVariables } from "@/models/mutations/types/SaveTemplateCharacteristicsOrder";
import LoadingButton from "@/components/core/controls/loading-button.component.vue";

const TemplateViewProps = Vue.extend({});

@Component({
  components: {
    draggable,
    LoadingButton
  }
})
export default class TemplateView extends TemplateViewProps {
  private isLoadingTemplate: boolean = true;
  private template: TemplateDetail | null = null;
  private loadingCompleted: boolean = false;
  private isSaving: boolean = false;
  private didDrag: boolean = false;

  private mounted() {
    const templateId = this.$route.params.id;
    graphqlClient
      .query<TemplateDetailResult, TemplateDetailVariables>({
        query: TEMPLATE_DETAIL_QUERY,
        variables: {
          templateId
        }
      })
      .then(result => {
        if (result.data && result.data.template) {
          this.template = {
            ...result.data.template,
            characteristics: (result.data.template.characteristics || []).sort((a, b) => a.order - b.order)
          };
          this.isLoadingTemplate = false;
          this.loadingCompleted = true;
        } else {
          this.template = result.data.template;
          this.isLoadingTemplate = false;
          this.loadingCompleted = true;
        }
      })
      .catch(e => {
        console.error(e);
        this.template = null;
        this.isLoadingTemplate = false;
        this.loadingCompleted = true;
      });
  }

  private saveOrder() {
    if (this.template && this.template.characteristics) {
      const order = this.template.characteristics.map((c, index) => ({
        order: index + 1,
        characteristicId: c.id
      }));
      this.isSaving = true;
      graphqlClient
        .mutate<SaveTemplateCharacteristicsOrderResult, SaveTemplateCharacteristicsOrderVariables>({
          mutation: SAVE_TEMPLATE_CHARACTERISTICS_ORDER,
          variables: {
            templateId: this.template.id,
            order
          }
        })
        .then(result => {
          this.isSaving = false;
          this.didDrag = false;
          this.$notify({
            title: this.$t("general.success") as string,
            text: this.$t("template_view.saving.success") as string,
            type: "success"
          });
        })
        .catch(e => {
          console.error(e);
          this.isSaving = false;
          this.$notify({
            title: this.$t("general.error.title") as string,
            text: this.$t("general.error.generic_error") as string,
            type: "error"
          });
        });
    }
  }
}
